const SvgHalted = (props) => (
  <svg height="1em" viewBox="0 0 10 2" width="1em" {...props}>
    <path d="M0 0h10v2H0z" fill="currentColor" fillRule="evenodd" />
  </svg>
)

export default SvgHalted
